
export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/ec83d30f1e38fc5d02fdc2004d3e50bc.jpg')`,
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-600/70"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-left max-w-2xl">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Secure Your Digital Life with Our VPN
          </h1>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Experience ultimate online privacy and security with OK TREND's advanced VPN solution. Browse anonymously, protect your data, and access content freely from anywhere in the world.
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all shadow-lg cursor-pointer whitespace-nowrap"
            >
              Get Started
            </button>
            <button
              onClick={() => {
                const element = document.getElementById('features');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
